function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { useWorkFlow } from "../../../../contexts/workflow";
import Sequences from "./sequences";
import Radio from "../../radio/radio";

/**
 * Permet de visualiser l'information de fin de séquence.
 */
var SequenceInformations = function SequenceInformations(_ref) {
  var elements = _ref.elements,
    index = _ref.index,
    onChange = _ref.onChange,
    showUnder = _ref.showUnder;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    sequences = _useState2[0],
    setSequences = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    repeatButton = _useState4[0],
    setRepeatButton = _useState4[1];
  var currentOrder = collector.currentOrder,
    specialData = collector.specialData,
    currentQuestion = collector.currentQuestion;
  var getSequenceNumber = function getSequenceNumber() {
    var firstLoop = currentOrder.indexOf('__blank') !== -1;
    var sequenceNumber = 1;
    // si c'est pas la 1ere boucle alors on peut afficher le résumé.
    if (!firstLoop) {
      currentOrder.split('.').forEach(function (key) {
        if (key.indexOf('_loop') !== -1) {
          var keyWithoutLoop = key.replace('_loop', '');
          var splitted = keyWithoutLoop.split('_');
          sequenceNumber = parseInt(splitted[splitted.length - 1], 10);
        }
      });
    }
    return sequenceNumber;
  };
  useEffect(function () {
    if (!specialData) {
      return;
    }
    var sequenceNumber = getSequenceNumber();
    var arrayOrder = currentOrder.split('.');
    arrayOrder.pop();
    if (currentQuestion.loop || arrayOrder[arrayOrder.length - 1] === '__blank_loop') {
      arrayOrder.pop();
    }
    var specialDataSequence = specialData['sequences' + arrayOrder.join('_')];
    var getSequences = {};
    if (specialDataSequence) {
      Object.keys(specialDataSequence).forEach(function (key) {
        if (key.indexOf('q_') === -1) {
          getSequences[key] = specialDataSequence[key];
        }
      });
    } else {
      getSequences = undefined;
    }
    setSequences(getSequences);
    setRepeatButton(showUnder === undefined && currentOrder.indexOf('__blank_loop') !== -1);
  }, [collector]);
  return /*#__PURE__*/React.createElement(Row, {
    className: "sequence-information"
  }, sequences && Object.keys(sequences).map(function (key, indexSequence) {
    if (showUnder && indexSequence + 1 >= showUnder) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Sequences, {
      elements: sequences[key],
      index: indexSequence
    });
  }), elements && repeatButton && /*#__PURE__*/React.createElement(Col, {
    className: "col-lg-4 col-md-6 col-sm-12"
  }, /*#__PURE__*/React.createElement(Radio, {
    elements: elements,
    onChange: onChange,
    index: index,
    disableLoader: true
  })));
};
export default SequenceInformations;